'use client';

import { useCallback } from 'react';
import { ThemeProvider } from './theme-provider';
import type { Theme } from '@/lib/theme/constants';
import { updateUserTheme } from '@/actions/account/update-theme';

interface Props {
  initialTheme: Theme;
  children: React.ReactNode;
}

/**
 * Wrapper que conecta el ThemeProvider con el server action `updateUserTheme`.
 * Mantener separado del provider puro para que sea fácil unit-testear el
 * provider sin depender de Auth.js.
 */
export function NqoroThemeProvider({ initialTheme, children }: Props) {
  const persist = useCallback((t: Theme) => {
    void updateUserTheme(t).catch(() => {});
  }, []);
  return (
    <ThemeProvider initialTheme={initialTheme} onPersist={persist}>
      {children}
    </ThemeProvider>
  );
}
